import { z } from "zod";
import { IsoTimestampSchema, UuidSchema } from "./common.js";
export const ContactResponseSchema = z.object({
    id: UuidSchema,
    tenant_id: UuidSchema,
    phone: z.string().nullable(),
    email: z.string().nullable(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    company: z.string().nullable(),
    source: z.string().nullable(),
    external_id: z.string().nullable(),
    metadata: z.record(z.unknown()),
    created_at: IsoTimestampSchema,
    updated_at: IsoTimestampSchema,
});
/** PATCH /contacts/:id request — all fields optional; at least one required. */
export const UpdateContactRequestSchema = z
    .object({
    phone: z
        .string()
        .regex(/^\+[1-9]\d{1,14}$/, "Phone must be in E.164 format (e.g. +15551234567)")
        .nullable()
        .optional(),
    email: z.string().email("Must be a valid email").nullable().optional(),
    first_name: z.string().max(100).nullable().optional(),
    last_name: z.string().max(100).nullable().optional(),
    company: z.string().max(200).nullable().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const ActivityEventResponseSchema = z.object({
    id: UuidSchema,
    tenant_id: UuidSchema,
    contact_id: UuidSchema.nullable(),
    actor: z.string(),
    event_type: z.string(),
    payload: z.record(z.unknown()),
    occurred_at: IsoTimestampSchema,
});
//# sourceMappingURL=crm.js.map